import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, onClick, variant = "primary", size = "default" }: ButtonProps) => (
  <StyledButton color={color} onClick={onClick} $variant={variant} $size={size}>
    {children}
  </StyledButton>
);
